<template>
  <div class="platform-income">
    <!-- 统计卡片 -->
    <div class="statistics-cards">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="stat-card income-card">
            <div class="stat-icon">
              <i class="el-icon-money"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">¥{{ statistics.totalIncome | priceFormat }}</div>
              <div class="stat-label">总收益</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card order-card">
            <div class="stat-icon">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ statistics.totalOrders }}</div>
              <div class="stat-label">总订单数</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card refund-card">
            <div class="stat-icon">
              <i class="el-icon-refresh"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">¥{{ statistics.totalRefund | priceFormat }}</div>
              <div class="stat-label">总退款金额</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card net-income-card">
            <div class="stat-icon">
              <i class="el-icon-trend-charts"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">¥{{ statistics.netIncome | priceFormat }}</div>
              <div class="stat-label">净收益</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 筛选条件 -->
    <div class="filter-section">
      <el-card>
        <el-form :inline="true" :model="filterForm" class="demo-form-inline">
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="filterForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
            >
            </el-date-picker>
          </el-form-item>
          
          <el-form-item label="快速选择">
            <el-select v-model="filterForm.quickSelect" placeholder="请选择" @change="handleQuickSelect">
              <el-option label="今日" value="today"></el-option>
              <el-option label="昨日" value="yesterday"></el-option>
              <el-option label="本周" value="week"></el-option>
              <el-option label="本月" value="month"></el-option>
              <el-option label="本季度" value="quarter"></el-option>
              <el-option label="本年" value="year"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付方式">
            <el-select v-model="filterForm.payType" placeholder="全部" clearable>
              <el-option label="余额" value="10"></el-option>
              <el-option label="微信" value="20"></el-option>
            
            </el-select>
          </el-form-item>

          <el-form-item label="支付状态">
            <el-select v-model="filterForm.payStatus" placeholder="全部" clearable>
              <el-option label="待支付" value="10"></el-option>
              <el-option label="已支付" value="20"></el-option>
              <el-option label="退还已返还" value="30"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
           
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 图表区域 -->
    <div class="chart-section">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-card>
            <template #header>
              <span>收益趋势图</span>
            </template>
            <div id="incomeChart" style="height: 400px;"></div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <template #header>
              <span>支付方式分布</span>
            </template>
            <div id="payTypeChart" style="height: 400px;"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 日期详情对话框 -->
    <el-dialog
      title="收益详情"
      v-model="detailDialogVisible"
      width="80%"
    >
      <!-- <OrderDetail :date="selectedDate" v-if="detailDialogVisible" /> -->
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
// import OrderDetail from './components/OrderDetail.vue';
import StoreApi from '@/api/store.js';

export default {
  name: 'PlatformIncome',
  components: {
    // OrderDetail
  },
  filters: {
    priceFormat(value) {
      if (!value) return '0.00';
      return parseFloat(value).toFixed(2);
    }
  },
  data() {
    return {
      loading: false,
      filterForm: {
        dateRange: [],
        quickSelect: '',
        payType: '',
        payStatus: '',
        startDate: '',
        endDate: ''
      },
      statistics: {
        totalIncome: 0,
        totalOrders: 0,
        totalRefund: 0,
        netIncome: 0
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      detailDialogVisible: false,
      selectedDate: '',
      incomeChart: null,
      payTypeChart: null
    };
  },
  mounted() {
    this.initDefaultDate();
    this.getStatistics();
    this.getTableData();
    this.$nextTick(() => {
      this.initCharts();
    });
  },
  beforeUnmount() {
    if (this.incomeChart) {
      this.incomeChart.dispose();
    }
    if (this.payTypeChart) {
      this.payTypeChart.dispose();
    }
  },
  methods: {
    // 初始化默认日期（本月）
    initDefaultDate() {
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      
      this.filterForm.startDate = this.formatDate(firstDay);
      this.filterForm.endDate = this.formatDate(lastDay);
      this.filterForm.dateRange = [this.filterForm.startDate, this.filterForm.endDate];
    },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 处理日期范围变化
    handleDateChange(value) {
      if (value && value.length === 2) {
        this.filterForm.startDate = value[0];
        this.filterForm.endDate = value[1];
      } else {
        this.filterForm.startDate = '';
        this.filterForm.endDate = '';
      }
      this.filterForm.quickSelect = '';
    },

    // 快速选择时间
    handleQuickSelect(value) {
      const now = new Date();
      let startDate, endDate;

      switch (value) {
        case 'today':
          startDate = endDate = this.formatDate(now);
          break;
        case 'yesterday':
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          startDate = endDate = this.formatDate(yesterday);
          break;
        case 'week':
          const weekStart = new Date(now);
          weekStart.setDate(now.getDate() - now.getDay());
          startDate = this.formatDate(weekStart);
          endDate = this.formatDate(now);
          break;
        case 'month':
          const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
          startDate = this.formatDate(monthStart);
          endDate = this.formatDate(now);
          break;
        case 'quarter':
          const quarter = Math.floor(now.getMonth() / 3);
          const quarterStart = new Date(now.getFullYear(), quarter * 3, 1);
          startDate = this.formatDate(quarterStart);
          endDate = this.formatDate(now);
          break;
        case 'year':
          const yearStart = new Date(now.getFullYear(), 0, 1);
          startDate = this.formatDate(yearStart);
          endDate = this.formatDate(now);
          break;
      }

      this.filterForm.dateRange = [startDate, endDate];
      this.filterForm.startDate = startDate;
      this.filterForm.endDate = endDate;
    },

    // 查询
    handleSearch() {
      this.pagination.currentPage = 1;
      this.getStatistics();
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.filterForm = {
        dateRange: [],
        quickSelect: '',
        payType: '',
        payStatus: '',
        startDate: '',
        endDate: ''
      };
      this.initDefaultDate();
      this.handleSearch();
    },

    // 获取统计数据
    async getStatistics() {
      try {
        this.loading = true;
        const params = {
          start_date: this.filterForm.startDate,
          end_date: this.filterForm.endDate,
          pay_type: this.filterForm.payType,
          pay_status: this.filterForm.payStatus
        };

        const response = await StoreApi.getIncomeStatistics(params);
        this.statistics = response.data;
        
        // 更新图表数据
        this.updateCharts(response.data.chartData);
      } catch (error) {
        console.error('获取统计数据失败:', error);
        this.$message.error('获取统计数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 获取表格数据
    async getTableData() {
      try {
        this.loading = true;
        const params = {
          page: this.pagination.currentPage,
          list_rows: this.pagination.pageSize,
          start_date: this.filterForm.startDate,
          end_date: this.filterForm.endDate,
          pay_type: this.filterForm.payType,
          pay_status: this.filterForm.payStatus
        };

        const response = await StoreApi.getIncomeList(params);
        this.tableData = response.data.list;
        this.pagination.total = response.data.total;
      } catch (error) {
        console.error('获取表格数据失败:', error);
        this.$message.error('获取表格数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 初始化图表
    initCharts() {
      this.incomeChart = echarts.init(document.getElementById('incomeChart'));
      this.payTypeChart = echarts.init(document.getElementById('payTypeChart'));
      
      // 设置默认图表选项
      this.setChartOptions();
    },

    // 设置图表选项
    setChartOptions() {
      // 收益趋势图
      const incomeOption = {
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>{a}: ¥{c}'
        },
        legend: {
          data: ['总收益', '净收益', '退款金额']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '¥{value}'
          }
        },
        series: [
          {
            name: '总收益',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '净收益',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '退款金额',
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      };

      // 支付方式分布图
      const payTypeOption = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: ¥{c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '支付方式',
            type: 'pie',
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      this.incomeChart.setOption(incomeOption);
      this.payTypeChart.setOption(payTypeOption);
    },

    // 更新图表数据
    updateCharts(chartData) {
      if (!chartData) return;

      // 更新收益趋势图
      if (chartData.incomeTrend) {
        this.incomeChart.setOption({
          xAxis: {
            data: chartData.incomeTrend.dates
          },
          series: [
            {
              name: '总收益',
              data: chartData.incomeTrend.totalIncomes
            },
            {
              name: '净收益',
              data: chartData.incomeTrend.netIncomes
            },
            {
              name: '退款金额',
              data: chartData.incomeTrend.refundAmounts
            }
          ]
        });
      }

      // 更新支付方式分布图
      if (chartData.payTypeDistribution) {
        this.payTypeChart.setOption({
          series: [{
            data: chartData.payTypeDistribution
          }]
        });
      }
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.getTableData();
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getTableData();
    },

    // 排序变化
    handleSortChange({ column, prop, order }) {
      // 处理排序逻辑
      console.log('排序:', prop, order);
    },

    // 查看详情
    viewDetail(row) {
      this.selectedDate = row.date;
      this.detailDialogVisible = true;
    },

    // 导出报表
    handleExport() {
      const params = {
        start_date: this.filterForm.startDate,
        end_date: this.filterForm.endDate,
        pay_type: this.filterForm.payType,
        pay_status: this.filterForm.payStatus
      };
      
      // 调用导出API
      StoreApi.exportIncomeReport(params).then(response => {
        // 处理导出逻辑
        this.$message.success('导出成功');
      }).catch(error => {
        this.$message.error('导出失败');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.platform-income {
  padding: 20px;
}

.statistics-cards {
  margin-bottom: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .stat-icon {
    font-size: 48px;
    margin-right: 20px;
    opacity: 0.8;
  }

  .stat-content {
    flex: 1;
  }

  .stat-value {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .stat-label {
    font-size: 14px;
    opacity: 0.9;
  }
}

.income-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.order-card {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.refund-card {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.net-income-card {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.filter-section {
  margin-bottom: 20px;
}

.chart-section {
  margin-bottom: 20px;
}

.table-section {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

// 响应式设计
@media (max-width: 768px) {
  .statistics-cards .el-col {
    margin-bottom: 15px;
  }
  
  .chart-section .el-col {
    margin-bottom: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/store/order/revenue.vue